import { ConcreteEncodable } from "./ConcreteEncodable";

import { PositionBookPairInfoImplEncoder } from "../../encoder/PositionBookPairInfoImplEncoder";

import * as CubiqTS from "../../index";
import { PositionBookPairInfo } from "../PositionBookPairInfo";

export class PositionBookPairInfoImpl extends ConcreteEncodable implements PositionBookPairInfo {
  public static enType: string = "com.bcdfx.model.PositionBookPairInfoImpl";

  /*FID=1*/
  public base: string;
  /*FID=2*/
  public nonBase: string;
  /*FID=3*/
  public defaultBook: CubiqTS.PositionBook | null = null;
  /*FID=4*/
  public positionBooks: Array<CubiqTS.PositionBook> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = PositionBookPairInfoImplEncoder.Instance;
    this.setEncodableType(PositionBookPairInfoImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "PositionBookPairInfoImpl[" +
      "base=" +
      this.base +
      "nonBase=" +
      this.nonBase +
      "defaultBook=" +
      this.defaultBook +
      "positionBooks=" +
      this.positionBooks +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
